function $df5bef30413a053b$export$61fc7d43ac8f84b0(func, ms) {
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = Number(setTimeout(()=>func(...args), ms));
    };
}
function $df5bef30413a053b$export$2077e0241d6afd3c(val, decimals) {
    return Math.round(val * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
function $df5bef30413a053b$export$29fb7152bd3f781a(color) {
    const a = color.saturation * Math.min(color.lightness, 1 - color.lightness);
    const getValue = (n)=>{
        const k = (n + color.hue / 30) % 12;
        return color.lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    return {
        red: getValue(0),
        green: getValue(8),
        blue: getValue(4)
    };
}


const $33af63f42a458671$var$panSensitivity = 0.5;
const $33af63f42a458671$var$zoomSensitivity = 1.7;
class $33af63f42a458671$export$2e2bcd8739ae039 {
    constructor(){
        this.zoom = 1;
        this.pan = {
            x: 0,
            y: 0
        };
        this.listeners = [];
        window.addEventListener("keydown", this.navigate.bind(this));
    }
    onUpdate(callback) {
        this.listeners.push(callback);
    }
    getPan() {
        return this.pan;
    }
    getZoom() {
        return this.zoom;
    }
    navigate(event) {
        switch(event.key){
            case "d":
            case "ArrowRight":
                this.pan.x += this.getPanFactor();
                break;
            case "a":
            case "ArrowLeft":
                this.pan.x -= this.getPanFactor();
                break;
            case "w":
            case "ArrowUp":
                this.pan.y -= this.getPanFactor();
                break;
            case "s":
            case "ArrowDown":
                this.pan.y += this.getPanFactor();
                break;
            case "=":
                this.zoom = Math.max(1, this.zoom * $33af63f42a458671$var$zoomSensitivity);
                break;
            case "-":
                this.zoom = Math.max(1, this.zoom / $33af63f42a458671$var$zoomSensitivity);
                break;
            case "r":
                this.zoom = 1;
                this.pan.x = 0;
                this.pan.y = 0;
                break;
            default:
                return;
        }
        this.notify();
    }
    notify() {
        this.listeners.forEach((listener)=>listener());
    }
    getPanFactor() {
        return $33af63f42a458671$var$panSensitivity * (1 / this.zoom);
    }
}


class $a40ebc379287e0be$export$2e2bcd8739ae039 {
    constructor(){
        this.startTime = Date.now();
    }
    elapsed() {
        return Date.now() - this.startTime;
    }
}



function $2f4d5440d89e6de9$export$ce6fff75687e7ab9(ms) {
    document.querySelector("[data-draw-time]").textContent = ms + "ms";
}
function $2f4d5440d89e6de9$export$1c70a6cc12bc0366(width, height) {
    document.querySelector("[data-draw-size]").textContent = width + "x" + height + "px";
}
function $2f4d5440d89e6de9$export$a9236ecf73157867(zoom) {
    document.querySelector("[data-zoom]").textContent = "x" + (0, $df5bef30413a053b$export$2077e0241d6afd3c)(zoom, zoom >= 10 ? 0 : 1);
}
function $2f4d5440d89e6de9$export$c0a704a878f3b9c1(n) {
    document.querySelector("[data-iterations]").textContent = `${n} iterations`;
}


const $1669b27dd88d6d65$var$escape = 2;
function $1669b27dd88d6d65$export$b65183c4047853ec(c, ci, iterations) {
    let z = 0;
    let zi = 0;
    /**
   * This area is always stable
   */ if (c < 0.25 && c > -0.6 && ci < 0.4 && ci > -0.4) return 0;
    for(let i = 0; i < iterations; i++){
        const newZ = z * z - zi * zi + c;
        const newZi = 2 * zi * z + ci;
        z = newZ;
        zi = newZi;
        if (Math.abs(z) > $1669b27dd88d6d65$var$escape || Math.abs(zi) > $1669b27dd88d6d65$var$escape) return Math.round(i / iterations * 100);
    }
    return 0;
}



const $4afb6f541ff15eb2$var$baseIterations = 128;
const $4afb6f541ff15eb2$var$maxIterations = 512;
const $4afb6f541ff15eb2$var$iterationZoomFactor = 0.001;
class $4afb6f541ff15eb2$export$2e2bcd8739ae039 {
    constructor(navigation, canvas){
        this.navigation = navigation;
        this.canvas = canvas;
    }
    draw() {
        const timer = new (0, $a40ebc379287e0be$export$2e2bcd8739ae039)();
        const { innerWidth: width, innerHeight: height } = window;
        const size = Math.min(width, height);
        const zoom = size * this.navigation.getZoom() / 2;
        const pan = this.navigation.getPan();
        const iterations = this.getIterations();
        const ctx = this.canvas.getContext("2d");
        if (!ctx) return;
        const imageData = ctx.createImageData(width, height);
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        this.canvas.width = width;
        this.canvas.height = height;
        $2f4d5440d89e6de9$export$1c70a6cc12bc0366(width, height);
        $2f4d5440d89e6de9$export$c0a704a878f3b9c1(iterations);
        $2f4d5440d89e6de9$export$a9236ecf73157867(this.navigation.getZoom());
        let pixelIndex = 0;
        for(let y = 0; y < height; y++){
            const ci = (y - halfHeight) / zoom + pan.y;
            for(let x = 0; x < width; x++){
                const c = (x - halfWidth) / zoom + pan.x;
                const inclusion = (0, $1669b27dd88d6d65$export$b65183c4047853ec)(c, ci, iterations);
                const color = this.createColor(inclusion);
                imageData.data[pixelIndex++] = color.red;
                imageData.data[pixelIndex++] = color.green;
                imageData.data[pixelIndex++] = color.blue;
                imageData.data[pixelIndex++] = 255;
            }
        }
        ctx.putImageData(imageData, 0, 0);
        $2f4d5440d89e6de9$export$ce6fff75687e7ab9(timer.elapsed());
    }
    createColor(inclusion) {
        return (0, $df5bef30413a053b$export$29fb7152bd3f781a)({
            hue: inclusion * 4 + 30,
            saturation: 1,
            lightness: inclusion * 2.55
        });
    }
    getIterations() {
        return Math.round(Math.min($4afb6f541ff15eb2$var$baseIterations + $4afb6f541ff15eb2$var$baseIterations * ((this.navigation.getZoom() - 1) * $4afb6f541ff15eb2$var$iterationZoomFactor), $4afb6f541ff15eb2$var$maxIterations));
    }
}


class $05fa019539fda0f5$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        element.addEventListener("click", this.open.bind(this));
        this.getModal().addEventListener("click", this.close.bind(this));
    }
    open() {
        this.getModal().classList.add("active");
    }
    close(event) {
        if (event.target instanceof Element && event.target.matches("[data-modal-close]")) this.getModal().classList.remove("active");
    }
    getModal() {
        const id = this.element.getAttribute("data-modal-trigger");
        return document.querySelector(`[data-modal="${id}"]`);
    }
}


const $ad2bcec7a0192558$var$updateDelay = 60;
const $ad2bcec7a0192558$var$canvas = document.getElementById("canvas");
const $ad2bcec7a0192558$var$navigation = new (0, $33af63f42a458671$export$2e2bcd8739ae039)();
const $ad2bcec7a0192558$var$visualization = new (0, $4afb6f541ff15eb2$export$2e2bcd8739ae039)($ad2bcec7a0192558$var$navigation, $ad2bcec7a0192558$var$canvas);
document.querySelectorAll("[data-modal-trigger]").forEach((element)=>new (0, $05fa019539fda0f5$export$2e2bcd8739ae039)(element));
const $ad2bcec7a0192558$var$debouncedDraw = (0, $df5bef30413a053b$export$61fc7d43ac8f84b0)($ad2bcec7a0192558$var$visualization.draw.bind($ad2bcec7a0192558$var$visualization), $ad2bcec7a0192558$var$updateDelay);
window.addEventListener("resize", $ad2bcec7a0192558$var$debouncedDraw);
$ad2bcec7a0192558$var$navigation.onUpdate($ad2bcec7a0192558$var$debouncedDraw);
$ad2bcec7a0192558$var$visualization.draw();


//# sourceMappingURL=repo.8b48fb8d.js.map
